module.exports = __webpack_public_path__ + "static/media/duvidas-sobre-como-comprar-imovel.4f41f0d6.png";